/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { PageViewModifierUI } from "components/hud/PageViewModifierUI";
import { inject } from "mobx-react";
import { pageViewModifiers } from "constants/enums";
import { showFitWidthMode, showFitPageMode, showFixedWidthMode } from "selectors/hudSelectors";
import { getPageViewModifier } from "selectors/zoom";
import { getViewPortWidthWithoutPagesViewScrollbar } from "selectors/documentViewSelectors";
import { HIDE_HUD_ICONS_THRESHOLD } from "constants/constants";
import { isPersonalCommentingEnabled } from "utils/FeatureFlagUtils";
import { shouldStartRendering } from "selectors/documentSelectors";
import { fitPageHandler, fitWidthHandler, fixWidthHandler, fitOneFullPageHandler } from "services/NavigationBarService";

const mapStoreToProps = stores => ({
  fitPageHandler,
  fitWidthHandler,
  fixWidthHandler,
  fitOneFullPageHandler,
  isFitWidthModeOn: () =>
    getPageViewModifier(stores) === pageViewModifiers.FIT_WIDTH ||
    (isPersonalCommentingEnabled(stores) &&
      stores.zoom.getIsCommentsPanelVisible() &&
      getPageViewModifier(stores) === pageViewModifiers.FIXED_WIDTH),

  showFitWidthMode: showFitWidthMode(stores),
  showFitPageMode: showFitPageMode(stores),
  showFixedWidthMode: (() =>
    getViewPortWidthWithoutPagesViewScrollbar(stores) > HIDE_HUD_ICONS_THRESHOLD && showFixedWidthMode(stores))(),
  getPageViewModifier: getPageViewModifier(stores),
  shouldStartRendering: shouldStartRendering(stores)
});

const PageViewModifierUIContainer = inject(mapStoreToProps)(PageViewModifierUI);

export { PageViewModifierUIContainer };
